module.exports = __webpack_public_path__ + "static/img/jclb1.cd94525.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jclb1.png
// module id = ORg7
// module chunks = 1